<template>
  <div>
    <v-form ref="form" v-model="formValid">
      <v-text-field
        name="channelAppKey"
        label="App Key *"
        v-model="formData.channelAppKey"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="channelAppSecret"
        label="App Secret *"
        v-model="formData.channelAppSecret"
        :rules="formRules.channelAppSecret"
        :placeholder="
          !formData.channelAppSecret && !formData.channelAppSecretEncrypted
            ? ''
            : '**********************************************'
        "
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="sellerEmail"
        label="Channel Email *"
        v-model="formData.sellerEmail"
        :rules="formRules.sellerEmailRules"
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="sellerPassword"
        label="Channel Password *"
        v-model="formData.sellerPassword"
        :rules="formRules.sellerPassword"
        :placeholder="
          !formData.sellerPassword && !formData.sellerPasswordEncrypted
            ? ''
            : '**********************************************'
        "
        outlined
        required
        type="password"
      ></v-text-field>

      <div class="tw-flex tw-flex-wrap tw-gap-x-8">
        <v-menu
          v-model="startDatePickerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formData.dateStartSyncSaleOrders"
              :rules="formRules.required"
              label="วันที่เริ่มดึงข้อมูล *"
              append-icon="mdi-chevron-down"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="formData.dateStartSyncSaleOrders"
            @input="startDatePickerMenu = false"
          ></v-date-picker>
        </v-menu>
        <v-menu
          ref="startTimePickerMenu"
          v-model="startTimePickerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="formData.timeStartSyncSaleOrders"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formData.timeStartSyncSaleOrders"
              :rules="formRules.required"
              label="เวลาที่เริ่มดึงข้อมูล *"
              append-icon="mdi-chevron-down"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="startTimePickerMenu"
            v-model="formData.timeStartSyncSaleOrders"
            full-width
            format="24hr"
            @click:minute="onSelectStartTimeMinute"
          ></v-time-picker>
        </v-menu>
      </div>

      <copy-text-field
        name="authCallbackUrl"
        label="Basic Callback URL"
        v-model="authCallbackUrl"
      />

      <copy-text-field
        name="pushCallbackUrl"
        label="Message Service Callback URL"
        v-model="pushCallbackUrl"
      />

      <v-text-field
        name="channelName"
        label="ชื่อช่องทางการเชื่อมต่อ (ภาษาไทย)*"
        v-model="formData.nameTH"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="channelName"
        label="ชื่อช่องทางการเชื่อมต่อ (ภาษาอังกฤษ)*"
        v-model="formData.nameEN"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <div class="tw-flex tw-justify-between tw-my-2">
        <v-btn color="error" outlined @click="$emit('delete')">
          <img class="tw-mr-2" src="/images/icons/delete.svg" />
          ลบช่องทางการเชื่อมต่อ
        </v-btn>
        <v-btn
          class="tw-text-lg"
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="onSave"
          >บันทึก
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import CopyTextField from '../../../form/copy-text-field.vue'
import _ from 'lodash'
import datetimeConverter from '../../../../../libs/datetimeConverter'
import rsa from '../../../../../libs/rsa'

const DEFAULT_FORM = {
  channelType: 2,
  channelAppKey: '',
  channelAppSecret: '',
  channelAppSecretEncrypted: '',
  sellerEmail: '',
  sellerPassword: '',
  sellerPasswordEncrypted: '',
  nameEN: '',
  nameTH: '',
  dateStartSyncSaleOrders: null,
  timeStartSyncSaleOrders: null,
}

export default {
  name: 'ShopChannelFormLazada',
  components: {
    CopyTextField,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    shopId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    formData: { ...DEFAULT_FORM },
    formValid: false,
    startDatePickerMenu: false,
    startTimePickerMenu: false,
    authCallbackUrl: 'https://phasicharoen.com/authCallbackLazada',
  }),
  computed: {
    formRules() {
      return {
        required: [v => !!v],
        channelAppSecret: [v => !!v || !!this.formData.channelAppSecretEncrypted],
        sellerEmailRules: [
          v => !!v,
          v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
        ],
        sellerPassword: [v => !!v || !!this.formData.sellerPasswordEncrypted],
      }
    },
    /** @return {string} */
    pushCallbackUrl() {
      if (!this.formData.id) {
        return ''
      }
      return `https://phasicharoen.com/pushSaleOrders/${this.companyId}/${this.shopId}/${this.formData.id}`
    }
  },
  methods: {
    setData(data) {
      // clone form data
      let newData = _.cloneDeep(data)

      // split date and time
      if (newData.timeStartSyncSaleOrders) {
        const dt = datetimeConverter.convertFirebaseTimestampToDateAndTime(newData.timeStartSyncSaleOrders)
        newData.dateStartSyncSaleOrders = dt.date
        newData.timeStartSyncSaleOrders = dt.time
      }

      this.formData = newData
      this.$refs.form.resetValidation()
    },
    onSelectStartTimeMinute() {
      this.$refs.startTimePickerMenu.save(this.formData.timeStartSyncSaleOrders)
    },
    async onSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      const data = { ...this.formData }

      // convert sync datetime to firebase comaptible and set to timeStartSyncSaleOrders
      if (data.dateStartSyncSaleOrders) {
        data.timeStartSyncSaleOrders = datetimeConverter.convertDateAndTimeToFirebaseTimestamp(data.dateStartSyncSaleOrders, data.timeStartSyncSaleOrders)
      }
      delete data.dateStartSyncSaleOrders

      // encrypt channelAppSecret
      if (data.channelAppSecret) {
        data.channelAppSecretEncrypted = rsa.encrypt(data.channelAppSecret)
      }

      // encrypt sellerPassword
      if (data.sellerPassword) {
        data.sellerPasswordEncrypted = rsa.encrypt(data.sellerPassword)
      }

      // delete unencrypted fields before save
      delete data.channelAppSecret
      delete data.sellerPassword

      await this.$store.dispatch('shopChannels/save', {
        companyId: this.companyId,
        shopId: this.shopId,
        channel: data,
      })
      this.loading = false
      this.$emit('save')
    }
  }
}
</script>
